import { RankCodeServer } from 'constants/index';


export const getAssetWithRank = (assetFolder, rank) => {
  let assetWithRank = {
    lineColor: '#262626',
    mainColor: '#434343',
    textDate: '#262626',
    textPoint: '#7b7b7b',
    textRankProgress: '#7b7b7b',
    specialIcon: ``,
    urlBackground: ``,
    bigIcon: `${assetFolder}/big_icon/un_rank.png`,
  };
  switch (rank.trim().toLowerCase()) {
    case RankCodeServer.DIAMOND: {
      assetWithRank = {
        lineColor: '#FFF8A8',
        mainColor: '#FFF',
        textDate: '#FFF8A9',
        textPoint: '#FFF8A9',
        textRankProgress: '#fff',
        urlBackground: `${assetFolder}/bg/diamond.png`,
        specialIcon: `${assetFolder}/icon/diamond_2.png`,
        bigIcon: `${assetFolder}/big_icon/diamond.png`,
      };
      break;
    }
    case RankCodeServer.PREMIERCLUBHSBC: {
      assetWithRank = {
        lineColor: '#FFF8A8',
        mainColor: '#FFF',
        textDate: '#FFF8A9',
        textPoint: '#FFF8A9',
        textRankProgress: '#fff',
        urlBackground: `${assetFolder}/bg/premier_club.png`,
        specialIcon: ``,
        bigIcon: `${assetFolder}/big_icon/diamond.png`,
      };
      break;
    }
    case RankCodeServer.PLATINUM: {
      assetWithRank = {
        lineColor: '#3D9A82',
        mainColor: '#0090F0',
        textDate: '#262626',
        textPoint: '#7b7b7b',
        textRankProgress: '#7b7b7b',
        urlBackground: `${assetFolder}/bg/platinum.png`,
        specialIcon: ``,
        bigIcon: `${assetFolder}/big_icon/platinum.png`,
      };
      break;
    }
    case RankCodeServer.GOLD: {
      assetWithRank = {
        lineColor: '#C4860B',
        mainColor: '#A86D0E',
        textDate: '#262626',
        textPoint: '#7b7b7b',
        textRankProgress: '#7b7b7b',
        urlBackground: `${assetFolder}/bg/gold.png`,
        specialIcon: ``,
        bigIcon: `${assetFolder}/big_icon/gold.png`,
      };
      break;
    }
    case RankCodeServer.SILVER: {
      assetWithRank = {
        lineColor: '#979797',
        mainColor: '#434343',
        textDate: '#262626',
        textPoint: '#7b7b7b',
        textRankProgress: '#7b7b7b',
        urlBackground: `${assetFolder}/bg/silver.png`,
        specialIcon: ``,
        bigIcon: `${assetFolder}/big_icon/silver.png`,
      };
      break;
    }
    case RankCodeServer.SILVERPLUS: {
      assetWithRank = {
        lineColor: '#979797',
        mainColor: '#434343',
        textDate: '#262626',
        textPoint: '#7b7b7b',
        textRankProgress: '#7b7b7b',
        urlBackground: `${assetFolder}/bg/silver.png`,
        specialIcon: ``,
        bigIcon: `${assetFolder}/big_icon/silver.png`,
      };
      break;
    }
    case RankCodeServer.MEMBER: {
      assetWithRank = {
        lineColor: '#262626',
        mainColor: '#434343',
        textDate: '#262626',
        textPoint: '#7b7b7b',
        textRankProgress: '#7b7b7b',
        bigIcon: `${assetFolder}/big_icon/un_rank.png`,
        specialIcon: ``,
        urlBackground: ``,
      };
      break;
    }
    default:
      break;
  }
  return assetWithRank;
};

export const checkMemberType = (rankName) => {
  switch (rankName.trim().toLowerCase()) {
    case RankCodeServer.MEMBER:
      return 'Chưa xếp hạng';
    case RankCodeServer.SILVER:
      return 'Silver';
    case RankCodeServer.PREMIERCLUBHSBC:
      return 'Premier Club';
    case RankCodeServer.SILVERPLUS:
      return 'Silver Member';
    case RankCodeServer.GOLD:
      return 'Gold';
    case RankCodeServer.PLATINUM:
      return 'Platinum';
    case RankCodeServer.DIAMOND:
      return 'Diamond';
    default:
      return 'Chưa xếp hạng';
  }
};
export const checkIndexShowToolTip = (rankName) => {
  switch (rankName.trim().toLowerCase()) {
    case RankCodeServer.MEMBER:
      return 0;
    case RankCodeServer.SILVER:
      return 1;
    case RankCodeServer.PREMIERCLUBHSBC:
      return 1;
    case RankCodeServer.SILVERPLUS:
      return 1;
    case RankCodeServer.GOLD:
      return 2;
    case RankCodeServer.PLATINUM:
      return 3;
    case RankCodeServer.DIAMOND:
      return 3;
    default:
      return 0;
  }
};
